<template>
    <transition name="fade">
        <div class="player" name="ppPdfView" v-if="visible">
            <div id="PlayerContent" class="pdf-content scorm">
                <div class="player-play" @click.stop="toFullScreen">
                    <svg style="margin-right:7px;" class="svg-icon" xmlns="http://www.w3.org/2000/svg"
                         xmlns:xlink="http://www.w3.org/1999/xlink">
                        <use xlink:href="/Content/dist/image_svg.svg#Play"></use>
                    </svg>
                </div>
                <div id="PlayerContentImg" class="scorm-img" :style="img"></div>
                <div class="scorm-show-close" style="display:none;" @click.stop="iosFullScreenClose"></div>
                <iframe :src="src" style="display:none;"></iframe>
            </div>
        </div>
    </transition>

</template>

<script>
    import UI from '../helpers/ui-helpers'
    import CM from '../helpers/common-mixin'

    export default {
        name: "scorm-viewer",

        props: ['title'],

        data(){
            return {
                src: null,
                img: null,
                visible: false,
                isMobile: UI.check_mobile(),
                inFullMode: false
            }
        },

        methods:{
            show(url, img) {
                //console.info('show -> url', url);
                let vm = this;


                vm.visible = true;
                vm.img = 'background-image:url(' + img + ')';
                this.$nextTick(() => {
                    //vm.setContainerSize();
                    vm.src = url;
                });

                vm.$emit('onPageChanged', 1);
            },

            onFullScreenExited(){
                $('[name=ppPdfView] iframe').hide();
                $('[name=ppPdfView] .scorm-img').show();
                $('[name=ppPdfView] .player-play').show();
                if (window.Flutter) {
                    window.Flutter.postMessage('onFullScreenExited');
                }
            },

            toFullScreen() {
                let isWebView = CM.methods.getUrlParameter('view') == 'webview';
                if (
                    (navigator.platform.indexOf("iPhone") != -1) ||
                    (navigator.platform.indexOf("iPod") != -1) ||
                    isWebView
                ) {
                    $('[name=ppPdfView] iframe').addClass('scorm-show');
                    $('.scorm-show-close').show();
                    $('#PlayerContentInfo').text('');
                } else { 
                    let elem = $('[name=ppPdfView] iframe').get(0);
                    let req = elem.requestFullScreen || elem.webkitRequestFullScreen || elem.mozRequestFullScreen;
                    req.call(elem);
                }
                $('[name=ppPdfView] .scorm-img').hide();
                $('[name=ppPdfView] iframe').show();
                $('[name=ppPdfView] .player-play').hide();
                if (window.Flutter) {
                    window.Flutter.postMessage('onFullScreen');
                }
            },
            iosFullScreenClose() {
                $('[name=ppPdfView] iframe').removeClass('scorm-show');
                $('.scorm-show-close').hide();
                $('[name=ppPdfView] .scorm-img').show();
                $('[name=ppPdfView] iframe').hide();
                $('[name=ppPdfView] .player-play').show();
                if (window.Flutter) {
                    window.Flutter.postMessage('onFullScreenExited');
                }
            }
        },

        created(){
            let vm = this;

            window.addEventListener('keydown', this.onkey);
            document.addEventListener("fullscreenchange", function () {
                vm.inFullMode = document.fullscreen;
                if(!vm.inFullMode){
                    vm.onFullScreenExited();
                }
            }, false);
            document.addEventListener("mozfullscreenchange", function () {
                vm.inFullMode = document.mozFullScreen;
                if(!vm.inFullMode){
                    vm.onFullScreenExited();
                }
            }, false);
            document.addEventListener("webkitfullscreenchange", function () {
                vm.inFullMode = document.webkitIsFullScreen;
                if(!vm.inFullMode){
                    vm.onFullScreenExited();
                }
            }, false);
        },

        mounted () {
            //$('body').append(this.$el);
        },

        destroyed(){
            window.removeEventListener('keydown', this.onkey);
            // document.removeEventListener('fullscreenchange');
            // document.removeEventListener('mozfullscreenchange');
            // document.removeEventListener('webkitfullscreenchange');
        }
    }
</script>

<style scoped>
    .pagefade-enter-active, .pagefade-leave-active {
        transition: all linear 0.05s;
    }
    .pagefade-enter, .pagefade-leave-to {
        opacity: 0;
    }

    iframe{
        width: 100%;
        height: 100%;
    }
    .scorm-show {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        z-index: 11000
    }
    .scorm-show-close {
        position: fixed;
        top: 50px;
        right: 15px;
        background: url(/Content/dist/icon-close.png?5770202fecb1913aa90b351f127f1bba) 50% no-repeat;
        height: 20px;
        width: 20px;
        cursor: pointer;
        z-index:12000
    }
</style>


// WEBPACK FOOTER //
// Content/src/components/ScormViewer.vue